import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link, useParams, NavLink } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { defaultOption } from "constants/ui/options";
import { nanoid } from "nanoid";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { getEmpFullNameTHByEmpData, getSupplierFullName, mapMstToOptions, pageInitSize, pageSizeOptions } from "utils/HelperFunction";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllGroupOfSupplier } from "../../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { getAllNewGr } from "../../../redux/handlers/logic/getAllNewGr.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import moment from "moment";
import FinancialStatus from "fragments/FinancialStatus";
import { NumericFormat } from "react-number-format";
import { debounce } from "@mui/material";
import { initFinancialStatusCount } from "mocks/grData";
export function CreditorList() {
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        page: 1,
        pageSize: pageInitSize,
        total: 0
    }), 2), pageModel = _useState1[0], setPageModel = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), tab = _useState2[0], setTab = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), tab0 = _useState3[0], setTab0 = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), tab1 = _useState4[0], setTab1 = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), tab2 = _useState5[0], setTab2 = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), tab3 = _useState6[0], setTab3 = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), tab4 = _useState7[0], setTab4 = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), Alldata = _useState8[0], setAlldata = _useState8[1];
    var _useState9 = _sliced_to_array(useState(null), 2), btnempstatus = _useState9[0], setBtnempstatus = _useState9[1];
    var _useState10 = _sliced_to_array(useState(initFinancialStatusCount), 2), financialStatusCount = _useState10[0], setFinancialStatusCount = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState11[0], setOptionsDistributorgroup = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState12[0], setOptionsGroupOfSuplier = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState13[0], setSelectedGroupOfSuplierID = _useState13[1];
    var _useState14 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState14[0], setGroupOfSupplier = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState15[0], setDistributorgroup = _useState15[1];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllNewGrReducer = useAppSelector(function(state) {
        return state.getAllNewGrReducer;
    });
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getData = function(page, limit, searchText, groupSubID, financialStatusID) {
        var modifyFinanStatusID = financialStatusID === 1 ? null : financialStatusID;
        var queryParams = {
            mstNewStatusID: 6,
            financialStatusID: modifyFinanStatusID,
            page: page,
            limit: limit,
            searchText: searchText,
            groupSubID: groupSubID
        };
        dispatch(getAllNewGr({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadAllMsts();
        getData(1, pageModel.pageSize, "", "", "", "");
    }, []);
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllNewGrReducer.isFetching);
        if (getAllNewGrReducer.data) {
            var result = getAllNewGrReducer.data.data.data;
            var meta = getAllNewGrReducer.data.data.meta;
            var finanStatusCount = getAllNewGrReducer.data.data.financialStatusCount;
            setData(result);
            setPageModel({
                page: meta.page,
                pageSize: meta.limit,
                total: meta.total
            });
            setTab(result);
            setFinancialStatusCount(finanStatusCount);
        // const status0 = result.filter(item => item.dim_mst_financial_status_id === null);
        // const status1 = result.filter(item => item.dim_mst_financial_status_id === 2 );
        // const status2 = result.filter(item => item.dim_mst_financial_status_id === 3 );
        // const status3 = result.filter(item => item.dim_mst_financial_status_id === 4 );
        // const status4 = result.filter(item => item.dim_mst_financial_status_id === 5 );
        // setTab0(status0);
        // setTab1(status1);
        // setTab2(status2);
        // setTab3(status3);
        // setTab4(status4);
        }
    }, [
        getAllNewGrReducer
    ]);
    var _useState16 = _sliced_to_array(useState(null), 2), filterText = _useState16[0], setFilterText = _useState16[1];
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText, selectedGroupOfSuplierID, btnempstatus) {
            getData(1, pageModel.pageSize, searchText, selectedGroupOfSuplierID, btnempstatus);
        }, 300);
    }, []);
    useEffect(function() {
        if (filterText !== null) {
            debouncedSearch(filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
        }
    }, [
        filterText
    ]);
    useEffect(function() {
        getData(1, pageModel.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
    }, [
        selectedGroupOfSuplierID,
        btnempstatus
    ]);
    // let filteredItems = data.filter((item) => {
    //     const docNumberMatches =
    //       item.doc_number &&
    //       item.doc_number.toLowerCase().includes(filterText.toLowerCase());
    //     const supplierNameMatches =
    //       item.dimSupplierInformation &&
    //       getSupplierFullName(item.dimSupplierInformation)
    //         .toLowerCase()
    //         .includes(filterText.toLowerCase());
    //     const supplierGroupMatches =
    //       !selectedGroupOfSuplierID ||
    //       (item.dimSupplierInformation &&
    //         item.dimSupplierInformation.dimGroupOfSupplier &&
    //         selectedGroupOfSuplierID ===
    //           item.dimSupplierInformation.dimGroupOfSupplier.id);
    //     return (docNumberMatches ||supplierNameMatches) && supplierGroupMatches;
    //   });
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่ GR",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(Link, {
                    to: "/financial-accounting/creditor/goods-receipt/".concat(row.id),
                    className: "text-[#565DFF] font-semibold underline",
                    children: row.doc_number
                });
            }
        },
        {
            field: "dimSupplierInformation",
            headerName: "ชื่อผู้จัดจำหน่าย",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimSupplierInformation ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            getSupplierFullName(row.dimSupplierInformation),
                            row.dimSupplierInformation.company_branch_name && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "(",
                                    row.dimSupplierInformation.company_branch_name || "-",
                                    ")"
                                ]
                            })
                        ]
                    }) : "-"
                });
            }
        },
        {
            field: "doc_receive_date",
            headerName: "วันที่รับสินค้า",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.doc_receive_date ? moment(row.doc_receive_date).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            field: "total_receive_quantity",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 0,
                    fixedDecimalScale: true,
                    value: row.total_receive_quantity
                });
            }
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่ารวมภาษี",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price
                });
            }
        },
        {
            field: "ex_vat_total_expense",
            headerName: "ค่าใช้จ่ายเพิ่มเติม",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.ex_vat_total_expense
                });
            }
        },
        {
            field: "total_price",
            headerName: "มูลค่ารวมทั้งหมด",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: row.grand_total_price + row.ex_vat_total_expense
                });
            }
        },
        {
            field: "dim_new_alldernow_emp_id",
            headerName: "ผู้รับสินค้า",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: getEmpFullNameTHByEmpData(row.createdNewGrEmp)
                });
            }
        },
        {
            field: "doc_due_date",
            headerName: "ครบกำหนดชำระ",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.doc_due_date ? moment(row.doc_due_date).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            headerName: "สถานะ",
            headerAlign: "center",
            id: "status",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var _row_dimMstFinancialStatus;
                var statusID = row.dim_mst_financial_status_id;
                var statusName = (_row_dimMstFinancialStatus = row.dimMstFinancialStatus) === null || _row_dimMstFinancialStatus === void 0 ? void 0 : _row_dimMstFinancialStatus.name;
                var docDueDate = row.doc_due_date;
                return /*#__PURE__*/ _jsx(FinancialStatus, {
                    statusID: statusID,
                    statusName: statusName,
                    docDueDate: docDueDate
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-4",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "การเงินและบัญชี"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: " GR Review  "
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "GR Review"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                },
                                children: "ทั้งหมด "
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                },
                                children: [
                                    "รอตรวจสอบ(",
                                    financialStatusCount["null"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 2 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(2);
                                },
                                children: [
                                    "บันทึกร่าง(",
                                    financialStatusCount["2"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 6 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(6);
                                },
                                children: [
                                    "รอแก้ไข(",
                                    financialStatusCount["6"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 3 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(3);
                                },
                                children: [
                                    "รอเชื่อมต่อ(",
                                    financialStatusCount["3"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 7 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(7);
                                },
                                children: [
                                    "รอชำระเงิน(",
                                    financialStatusCount["7"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 4 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(4);
                                },
                                children: "ชำระเงินแล้ว"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 5 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(5);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1 pd",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier,
                                                id: "1"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                getRowHeight: function() {
                                    return "auto";
                                },
                                loading: getAllNewGrReducer.isFetching,
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData(newPagination.page + 1, newPagination.pageSize, filterText || "", selectedGroupOfSuplierID, btnempstatus || "");
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: columnsd,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    "& .MuiDataGrid-cell": {
                                        fontSize: "16px",
                                        fontFamily: "Sarabun"
                                    },
                                    "& .MuiDataGrid-columnHeader": {
                                        fontSize: "16px",
                                        fontFamily: "Sarabun"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
